import { ActivityColor } from '../types/map.types';

/**
 * Utilitaires pour la carte
 */

/**
 * Retourne la couleur associée à une activité
 */
export const getActivityColor = (activity: string): string => {
  const colors: ActivityColor = {
    'rock_climbing': '#e74c3c',
    'skitouring': '#3498db',
    'hiking': '#27ae60',
    'mountain_climbing': '#f39c12',
    'snow_ice_mixed': '#9b59b6',
    'ice_climbing': '#1abc9c',
    'snowshoeing': '#34495e',
    'mountain_biking': '#e67e22',
    'via_ferrata': '#95a5a6',
    'slacklining': '#f1c40f'
  };
  return colors[activity] || '#7f8c8d';
};

/**
 * Génère une couleur unique basée sur l'ID d'un massif
 */
export const getRangeColor = (id: number): string => {
  const colors = [
    '#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6',
    '#1abc9c', '#34495e', '#e67e22', '#95a5a6', '#f1c40f',
    '#c0392b', '#2980b9', '#27ae60', '#d35400', '#8e44ad',
    '#16a085', '#2c3e50', '#d68910', '#7f8c8d', '#f4d03f',
    '#a93226', '#1f618d', '#239b56', '#b7950b', '#6c3483',
    '#138d75', '#1b2631', '#ca6f1e', '#566573', '#d4ac0d'
  ];
  return colors[id % colors.length];
};
